import { useMatches } from '@tanstack/react-router';

import { ContactInfoSidebar } from '../chat/-components';
import { Route } from '../route';
import { DashboardHeader } from './header';
import { Navbar } from './navbar';

import { Route as ChatRoute } from '../chat';

export function DashboardLayout({
  children,
}: {
  sidebar?: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}) {
  const { contactInfoSidebarContactId, navbarOpen } = Route.useRouteContext();

  const matches = useMatches();
  const paths = matches.map((match) => match.id);

  const chatOpen = paths.includes(ChatRoute.id);

  return (
    <div className="flex h-screen w-screen items-stretch overflow-hidden">
      <div className="relative flex flex-row-reverse">
        <Navbar open={navbarOpen} />
      </div>

      <div className="flex flex-grow flex-col">
        <DashboardHeader />

        <main className="container relative mx-auto flex flex-grow flex-col p-0 px-0">
          {children}
        </main>
        {/* <footer className="">footer</footer> */}
      </div>

      <ContactInfoSidebar
        active={chatOpen}
        contactId={contactInfoSidebarContactId}
      />
    </div>
  );
}
